import { IS_BP_MANAGER } from "@/consts";
import type { Maybe } from "@/graphql/generated-types";
import type { IMultiSelectItem } from "@/interfaces";
import type { EntityWithId } from "@/types";
import type { Ref } from "vue";

type StoreWithShaedOption = {
  departments: string[];
  externalDepartments: string[];
  groups: string[];
  externalGroups: string[];
  parentGroups: string[];
};

type SharedOptionsReturn = {
  departments?: string[];
  groups?: string[];
};

const toSelectableIds = (
  listItems: Ref<IMultiSelectItem[]>,
  entities?: Maybe<EntityWithId[]>,
) => {
  const ids = (entities || []).map((item) => item.id);
  return ids.filter((id) =>
    listItems.value.map((option) => option.id).includes(id),
  );
};

const toSharedOptions = (store: StoreWithShaedOption): SharedOptionsReturn => {
  // BP Manager has only one department. We shouldn't send anything. BE handles it
  if (IS_BP_MANAGER) {
    return {
      departments: undefined,
      groups: undefined,
    };
  }

  return {
    departments: [...store.departments, ...store.externalDepartments],
    groups: [...store.groups, ...store.externalGroups, ...store.parentGroups],
  };
};
const toList = (list: Ref<IMultiSelectItem[]>, ids?: Maybe<string[]>) => {
  return (ids || [])
    .map((id) => {
      return list.value.find((item) => item.id === id);
    })
    .filter((item) => !!item);
};

export default {
  toSelectableIds,
  toSharedOptions,
  toList,
};
